if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

    $('.images-slides').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 500,
        fade: true,
        accessibility: false
    });

    $('.images-list').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 500,
        fade: true,
        accessibility: false
    });

    $('.intro-slides').slick({
        arrows: false,
        dots: true,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 500,
        fade: true,
        accessibility: false
    });

    $('.slider-info-slides').slick({
        arrows: false,
        dots: true,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 700,
        fade: true,
        accessibility: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    draggable:true,
                }
            }
        ]
    });

    $('.carousel-slider').slick({
        arrows: true,
        dots: true,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 700,
        slidesToScroll: 1,
        accessibility: true,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 2,
                    asNavFor: '.carousel-text-slider',
                    centerMode: true,
                    centerPadding: '0px',
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });

    $(".carousel-slider .carousel-item .info").hover(
        function() {
            let slideIndex = $(this).data('count');
            console.log(slideIndex);
            $('.carousel-text-slider').slick('slickGoTo', slideIndex, false);
        }, function() {

        }
    );


    $('.carousel-text-slider').slick({
        arrows: false,
        dots: false,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 500,
        fade: true,
        accessibility: false,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    asNavFor: '.carousel-slider',
                    infinite: true,
                }
            }
        ]
    });

    $('.slider-rooms-slider').slick({
        arrows: true,
        dots: false,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 700,
        slidesToShow: 2,
        slidesToScroll: 1,
        asNavFor: '.slider-rooms-menu',
        accessibility: true
    });

    $('.slider-rooms-menu').slick({
        arrows: false,
        dots: false,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 700,
        slidesToShow: 3,
        slidesToScroll: 1,
        accessibility: true,
        centerMode: true,
        focusOnSelect: true,
        centerPadding: '0px',
        asNavFor: '.slider-rooms-slider'
    });

    let ScrollDown = document.getElementsByClassName('js-scrolldown');
    if(ScrollDown.length > 0){
        ScrollDown[0].addEventListener('click', function(){
            animateto('intro');
        });
    }

    $('.slider-rooms-item .info-add .info-content').hover(
        function(){
            $(this).parent().css("opacity", "1");
            $(this).removeClass('close');
            $(this).parent().parent().animate({width: "+=160"},80);
            $(this).parent().parent().siblings('.slick-active').animate({width: "-=160"},80);
            $(this).parent().parent().siblings('.slick-active').addClass('color-neutral');
        }, function() {
            $(this).parent().css("opacity", "0");
            $(this).addClass('close');
            $(this).parent().parent().animate({width: "-=160"},80);
            $(this).parent().parent().siblings('.slick-active').animate({width: "+=160"},80);
            $(this).parent().parent().siblings('.slick-active').removeClass('color-neutral');
        }
    );

    $('a[href^="#"]:not(a[data-fancybox])').click(function(e){
        e.preventDefault();
        let strAncla = $(this).prop('hash').substr(1);
        animateto(strAncla);
    });

})();

function animateto(target){
    var gotoTarget = offset(document.getElementById(target)).top - 130;
    var from     = window.pageYOffset
    var to       = gotoTarget
    var duration = 1300;
    var start = new Date().getTime()

    //time interval
    var timer = setInterval(function() {
        var time = new Date().getTime() - start

        if(from <= to ){
            var y = easeInOutQuart(time, from, to - from, duration)
        } else {

            var y = easeInOutQuart(time, from, -(from - to), duration)
        }
        window.scrollTo(0, y)
        if (time >= duration) clearInterval(timer)

    }, 1000 / 60);

    window.scrollTo(0, from)

}
//ease movement
function easeInOutQuart(t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}